import { Name, Position, TripBusiness, TypeClass } from "./_fields";
import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";

type BusinessTicketTemplate = {
  Name: string;
  Position: string;
  Class: string;
  TripBusiness: string;
};

export const businessTicketTemplate: TemplatesValue<BusinessTicketTemplate> = {
  fileName: "DanhSachCapVeCongTac",
  sheet: DEFAULT_SHEET_NAME,
  structures: [Name, Position, TripBusiness, TypeClass],
  fields: ["Name", "Position", "TripBusiness", "Class"],
};
